<template>
  <div class="pb-8">
    <app-header
      :links="headerLinks"
    />
    <main class="py-4 px-3 md:px-0">
      <slot />
    </main>

    <bottom-bar />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import AppHeader from "@/components/AppHeader";
import UiLink from "@/components/ui/UiLink";
import BottomBar from './BottomBar.vue';

export default defineComponent({
  name: "AppShell2",

  components: {UiLink, AppHeader, BottomBar},

  data() {
    return {
      headerLinks: [
        {
          exact: true,
          title: 'Collections',
          to: {name: 'Collections'},
          children: [
            { title: 'Trending', to: {name: 'Collections', params: { currentTab: 'trending' }} },
            { title: 'Minting Now', to: {name: 'Collections', params: { currentTab: 'minting' }} },
            { title: 'Owned', to: {name: 'Collections', params: { currentTab: 'own' }} },
            { title: 'Watchlist', to: {name: 'Collections', params: { currentTab: 'watchlist' }} },
          ]
        },
        {
          title: 'Crates',
          to: {name: 'Crates'}
        },
        {
          title: 'Feed',
          to: {name: 'Wallets'}
        },
        {
          title: 'Alerts',
          to: {name: 'Alerts'}
        },
        {
          title: 'Calendar',
          to: {name: 'Calendar'}
        },
        {
          title: 'Pulse',
          to: {name: 'Pulse'},
        },
      ]
    }
  }
});
</script>

<style scoped>

</style>
